import * as React from "react";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { useAppSelector} from "../redux/Hook";
import Header from "./Header";
import {StyledEngineProvider} from "@mui/material/styles";
import useCustomStyles from "../hooks/CustomStylesHook";
import {keyframes} from "@emotion/react";

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const styles = (theme: any) => ({
    wrapperContainer: {
        display: "flex",
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 30%, ${theme.palette.secondary.main} 100%)`,
        color: "#fff",
        animation: `${fadeIn} 1.5s ease-out`,
        overflow: "hidden",
    },

    contentBoxContainer: {
        padding: "0 1% 0 1%",
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 30%, ${theme.palette.secondary.main} 100%)`,
        color: "#fff",
        animation: `${fadeIn} 1.5s ease-out`,
        overflow: "hidden",
    },
    customBackground: {
        flexGrow: 1,
        height: "100vh",
        overflow: "auto",
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 30%, ${theme.palette.secondary.main} 100%)`,
    },
});


const Wrapper = (props: {
    children:
        | string
        | number
        | boolean
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | Iterable<React.ReactNode>
        | React.ReactPortal
        | null
        | undefined;
}) => {
    const themeDataState = useAppSelector((state) => state.UpdateTheme);

    const theme = createTheme({
        palette: {
            mode: themeDataState?.mode,
            primary: {
                main: themeDataState?.primary,
                light: themeDataState?.primaryLight,
                contrastText: "#f8f9fa",
            },
            secondary: {
                main: themeDataState?.secondary,
                contrastText: "#f8f9fa",
            },
            error: {
                main: themeDataState?.error,
            },
        },
        typography: {
            fontFamily: "Helvetica, Arial, sans-serif",
        },
    });

    const classes = useCustomStyles(styles, theme);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <Box className={classes?.wrapperContainer}>
                    <CssBaseline/>
                    <Header/>
                    <Box
                        component="main"
                        className={classes?.customBackground}
                        sx={{
                            backgroundColor: (theme) =>
                                theme.palette.mode === "light"
                                    ? theme.palette.grey[100]
                                    : theme.palette.grey[900],
                        }}
                    >
                        <Toolbar/>
                        <Box className={classes?.contentBoxContainer}>
                            {props?.children}
                        </Box>
                    </Box>
                </Box>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default Wrapper;

/* Control Flow: index -> App -> Wrapper */
